<template>
  <v-dialog
    v-model="isShow"
    persistent
    max-width="300"
  >
    <v-card>
      <v-card-title color="primary">
        <div style="text-align: cetner">
          Edit
        </div>
      </v-card-title>
      <v-card-text>
        <croppa
          style="inline-height: 0;"
          :width="250"
          :height="250"
          :file-size-limit="10000000"
          :prevent-white-space="true"
          placeholder-color="black"
          :placeholder-font-size="50"
          placeholder="✚"
          :show-remove-button="false"
          :remove-button-size="30"
          v-model="croppa"
          :initial-image="initialImage"
        >
        </croppa>
        <div
          class="d-flex justify-space-between align-center"
          style="height:44px;"
        >
          <div
            class="d-flex"
            style="font-size:17px;line-height:22px;color:#5b5957;"
          >
            Rotate
          </div>
          <div
            class="d-flex justify-end"
          >
            <svg
              style="cursor:pointer"
              @click="croppa.rotate()"
              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path id="icon/image/crop_rotate_24px" fill-rule="evenodd" clip-rule="evenodd" d="M6.33943 1.39203C8.00943 0.502117 10.1694 -0.117821 12.6094 0.0321644L8.79943 3.84178L7.46943 2.51192C4.37943 3.97177 2.12943 6.88148 1.57943 10.3711C1.51943 10.7811 1.13943 11.0611 0.719425 10.9911C0.309425 10.9311 0.0294247 10.5411 0.0994263 10.1312C0.699425 6.33153 3.05943 3.13185 6.33943 1.39203ZM14.9994 15.9906H4.99943C4.44942 15.9906 3.99943 16.4405 3.99943 16.9905C3.99943 17.5404 4.44942 17.9904 4.99943 17.9904H5.99943V18.9903C5.99943 19.5402 6.44942 19.9902 6.99943 19.9902C7.54943 19.9902 7.99942 19.5402 7.99942 18.9903V17.9904H15.9994C17.0994 17.9904 17.9994 17.0905 17.9994 15.9906V7.99137H18.9994C19.5494 7.99137 19.9994 7.54141 19.9994 6.99147C19.9994 6.44152 19.5494 5.99157 18.9994 5.99157H17.9994V4.99167C17.9994 4.44172 17.5494 3.99177 16.9994 3.99177C16.4494 3.99177 15.9994 4.44172 15.9994 4.99167V14.9907C15.9994 15.5406 15.5494 15.9906 14.9994 15.9906ZM7.99942 13.9908V8.99127C7.99942 8.44132 8.44942 7.99137 8.99942 7.99137H13.9994V5.99157H7.99942C6.89943 5.99157 5.99942 6.89148 5.99942 7.99137V13.9908H7.99942ZM22.4194 13.6208C21.8694 17.1105 19.6194 20.0202 16.5294 21.48L15.1994 20.1502L11.3894 23.9698C13.8294 24.1198 15.9894 23.4998 17.6594 22.6099C20.9394 20.8701 23.2994 17.6704 23.8994 13.8608C23.9694 13.4508 23.6894 13.0609 23.2794 13.0009C22.8594 12.9309 22.4794 13.2108 22.4194 13.6208Z" fill="#929191"/>
            </svg>
          </div>
        </div>
        <div
          class="d-flex justify-space-between align-center"
          style="height:44px;"
        >
          <div
            class="d-flex"
            style="font-size:17px;line-height:22px;color:#5b5957;"
          >
            Cover Photo
          </div>
          <div
            class="d-flex justify-end"
          >
            <v-switch
              v-model="isCover"
              inset
              class="cover-photo__switch"
              color="#FF5500"
              :hide-details="false"
              :ripple="false"
            ></v-switch>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          style="text-transform:none !important"
          @click="isShow = false"
        >Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          style="text-transform:none !important"
          @click="doOk"
          :disabled="isProcess"
          :loading="isProcess"
        >OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import service from '@/plugins/service'

export default {
  data: () => ({
    isShow: false,
    isProcess: false,
    croppa: {},
    id: '',
    uid: '',
    isCover: false,
    initialImage: '',
  }),
  methods: {
    show(uid, id, isCover, initialImage) {
      this.id = id
      this.uid = uid
      this.isCover = isCover
      this.initialImage = initialImage
      if (this.croppa.refresh) {
        this.croppa.refresh()
      }
      this.isShow = true
    },
    async doOk() {
      try {
        this.isProcess = true
        // 登録する
        const data = await this.uploadPhoto()
        if (!Array.isArray(data)) {
          return
        }
        const res = data[0]
        res.isCover = this.isCover
        this.$emit('change', res)
      } catch (e) {
        service.log(e)
      } finally {
        this.isProcess = false
        this.isShow = false
      }
    },
    uploadPhoto() {
      return new Promise((resolve) => {
        this.croppa.generateBlob(async (blob) => {
          const json = await service.postEditPhoto(this.uid, this.id, blob)
          resolve(json.res)
        })
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.croppa-container
  background-color #FAFAFA
  border-radius 5px
  border 2px solid gray
  height 250px

.cover-photo__switch
  margin-right -12px
</style>
